import { ElementRef, Injectable, ChangeDetectorRef } from '@angular/core';

@Injectable()
export class ResizableColumnService {
  private resizableColumnDefinitions: any[] = [];
  private tableMinWidth: number = 0;
  private initialRatio: number = 1;
  private initialWindowWidth: number = window.innerWidth;
  private initialTableWidth: number = 0;
  private el: ElementRef;
  private changeDetectorRef: ChangeDetectorRef;

  setConfig(resizableColumnDefinitions: any[], tableMinWidth: number, tableElement: ElementRef, changeDetectorRef: ChangeDetectorRef): void {
    this.resizableColumnDefinitions = resizableColumnDefinitions;
    this.tableMinWidth = tableMinWidth;
    this.el = tableElement;
    this.changeDetectorRef = changeDetectorRef;
  }

  getColumnWidth(column: string): number {
    const element = this.resizableColumnDefinitions.find((x) => x.column === column);
    return element ? Math.max(element.minWidth, element.width) : 0;
  }

  onResize(): void {
    this.setTableRatio();
    this.resizeTable();
    this.adjustColumnWidths();
  }

  private getTableElement(): HTMLElement | null {
    return this.el.nativeElement;
  }

  private resizeTable(): void {
    const tableElement = this.getTableElement();
    if (!tableElement) return;
  
    this.initialTableWidth ||= tableElement.clientWidth;
  
    const newWidth = Math.max(this.initialRatio * this.initialTableWidth, this.tableMinWidth);
    tableElement.style.width = `${newWidth}px`;
  }

  private setTableRatio(): void {
    if (!this.initialWindowWidth) {
      this.initialWindowWidth = window.innerWidth;
    }
  
    this.initialRatio = window.innerWidth / this.initialWindowWidth;
  }

  private adjustColumnWidths(): void {
    const tableElement = this.getTableElement();
    if (!tableElement) return;
  
    const currentTableWidth = tableElement.clientWidth;
    const totalMinWidths = this.resizableColumnDefinitions.reduce((sum, col) => sum + col.minWidth, 0);
    const availableSpace = currentTableWidth - this.tableMinWidth;
  
    this.resizableColumnDefinitions.forEach((column) => {
      if (availableSpace < 0) {
        const scaleFactor = currentTableWidth / this.tableMinWidth;
        column.width = Math.max(column.minWidth, column.minWidth * scaleFactor);
      } else {
        const minWidthRatio = column.minWidth / totalMinWidths;
        column.width = Math.max(column.minWidth, column.minWidth + availableSpace * minWidthRatio);
      }
    });

    this.changeDetectorRef.detectChanges();
  }
}
